import { DiscoverFields } from "./fields";
import { DiscoverConstants } from "./discoverConstants";

export const ActionSpecifDetail = {
  "0302": {
    description: "Update BEN Indicator",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      }
    ]
  },
  "03030": {
    description: "Reverse Chargeback",
    fields: [
      {
        fieldObject: DiscoverFields.reversalAmount,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  "03034": {
    description: "Issuer Pre-Arbitration Inquiry Request",
    hasReasonCode: true,
    reasonCodeCondtional: {
      parentField: DiscoverFields.changeReasonOrAmount,
      parentValue: true
    },
    fields: [
      {
        fieldObject: DiscoverFields.changeReasonOrAmount,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.changeReasonOrAmount,
        parentValue: false
      }
    ]
  },
  "03036": {
    description: "Correct Reason Code",
    hasReasonCode: true
  },
  "03038": {
    description: "Initiate ChargeBack",
    hasReasonCode: true
  },
  "03056": {
    description: "Reopen Cancel Case",
    hasReasonCode: true
  },
  "03066": {
    description: "Issuer Arbitration Request",
    fields: [
      {
        fieldObject: DiscoverFields.documentationIndicator,
        isRequired: true,
        isParent: true,
        isDependant: true,
        parent: DiscoverFields.image,
        parentValue: false
      },
      {
        fieldObject: DiscoverFields.docType,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.documentationIndicator,
        parentValue: [
          DiscoverConstants.DocumentationIndicators[1].value,
          DiscoverConstants.DocumentationIndicators[3].value
        ]
      },
      {
        fieldObject: DiscoverFields.image,
        isParent: true,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.documentationIndicator,
        parentValue: false
      },
      {
        fieldObject: DiscoverFields.cashOverOption,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: true
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/configurations/discoverConfigs/actionCodes.js